/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse,
  StandardError,
  UserPublic
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Public User
 */
export const publicUser = (
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      username = toValue(username);

      return axiosClient<UserPublic>(
      {url: `/public/users/${username}`, method: 'GET', signal
    },
      );
    }




export const getPublicUserQueryKey = (username: MaybeRefOrGetter<string>,) => {
    return [
    'public','users',username
    ] as const;
    }


export const getPublicUserQueryOptions = <TData = Awaited<ReturnType<typeof publicUser>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(username: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicUserQueryKey(username);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicUser>>> = ({ signal }) => publicUser(username, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(username) !== null && toValue(username) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicUser>>, TError, TData>
}

export type PublicUserQueryResult = NonNullable<Awaited<ReturnType<typeof publicUser>>>
export type PublicUserQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public User
 */

export function usePublicUser<TData = Awaited<ReturnType<typeof publicUser>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 username: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicUser>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicUserQueryOptions(username,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






